import React, { useState, useEffect, useContext } from 'react';
import { LanguageContext } from '../LanguageContext'; // For i18n
import axios from 'axios'; // If using the backend at all
// import '../components/CSS_FILE.css'; // For styling
import NavBar from '../components/NavBar'; // For top
import BottomBar from '../components/BottomBar'; // For bottom

// This relies on the frontend .env file
// Note that const cannot be above import statements
const BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

function Latin() {
    const [pdfUrl, setPdfUrl] = useState(null);
    const { t, setLanguage } = useContext(LanguageContext);

    useEffect(() => {
        const desiredPdf = 'LatinExegesis.pdf';

        fetch(`${BASE_URL}/api/pdf?name=${encodeURIComponent(desiredPdf)}`)
            .then(response => response.blob())
            .then((blob) => {
                // Create a blob URL for the PDF blob
                const url = URL.createObjectURL(blob);
                setPdfUrl(url);
            })
            .catch((error) => {
                console.error("Error fetching PDF:", error);
            });
    }, []);

    return (
        <>
            <NavBar />
            {pdfUrl ? (
                <iframe
                    className="pdf-frame"
                    src={pdfUrl}
                    title="PDF Viewer"
                    allow="fullscreen"
                />
            ) : (
                <div className="loading-text">
                    {/* <div className="spinner"></div> */}
                    <p>{t('pdfloading')}</p>
                </div>
            )}
            {/* <BottomBar /> */}
        </>
    );
};

export default Latin;